import React from "react";
import { Route } from "react-router-dom";
//
import { URL } from "../url";
// component
import LayoutRoot from "../layout/layout_root";
import PrivateRoute from "../component/private_route";

//
import BailiffListing from "screen/03_Bailiff/01_List/bailiff_list";
import BailiffDetail from "screen/03_Bailiff/02_Detail/bailiff_detail";
import SegmentScreen from "screen/03_Bailiff/03_Segment/segment_screen";
import KycApprove from "screen/04_Kyc_Approve/kyc_approve";
import VirtualMachine from "screen/05_Virtual_Machine/virtual_machine";
import DebugJobScreen from "screen/06_Debug_Job/debug_job";
import DevScreen from "screen/100_Dev/dev";
//concept

const PERMISSION_SCREEN = "fdb";
const KYC_SCREEN = "ubpk";
const VM_SCREEN = "acm";
const DEBUG_SCREEN = "oadbj";

export const routerPrivate = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------
  const groupBailiff = () => {
    return (
      <>
        <Route
          index
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<BailiffListing />}
            />
          }
        />
        <Route
          path={URL.bailiffDetail}
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<BailiffDetail />}
            />
          }
        />
        <Route
          path={URL.segment}
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<SegmentScreen />}
            />
          }
        />
      </>
    );
  };

  const groupKyc = () => {
    return (
      <Route
        path={URL.kyc}
        element={
          <PrivateRoute require={[KYC_SCREEN]} element={<KycApprove />} />
        }
      />
    );
  };

  const groupVM = () => {
    return (
      <>
        <Route
          path={URL.vm}
          element={
            <PrivateRoute require={[VM_SCREEN]} element={<VirtualMachine />} />
          }
        />
      </>
    );
  };

  const groupDebug = () => {
    return (
      <>
        <Route
          path={URL.debugJob}
          element={
            <PrivateRoute
              require={[DEBUG_SCREEN]}
              element={<DebugJobScreen />}
            />
          }
        />
      </>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={"/"} element={<LayoutRoot />}>
      {groupBailiff()}
      {groupKyc()}
      {groupVM()}
      {groupDebug()}
      <Route path="/dev" element={<DevScreen />} />
    </Route>
  );
};
